global.modules.set({
  async init(context) {
    $('.double_range', context).each(function () {
      var elem = $(this);
      var minGap = 0;
      var sliderOne = elem.find('input[type="range"]:eq(0)');
      var sliderTwo = elem.find('input[type="range"]:eq(1)');
      var inputOne = elem.find('input[type="number"]:eq(0)');
      var inputTwo = elem.find('input[type="number"]:eq(1)');
      var sliderTrack = elem.find(".progress-part");
      var sliderGap = sliderOne.attr('max') - sliderOne.attr('min');
      var sliderMinValue = sliderOne.attr('min');
      fillColor();
      function handleInput(el1, el2, condition, newValue) {
        if (condition) {
          el1.val(newValue);
        } else {
          el2.val(el1.val());
          fillColor();
        }
      }
      sliderOne.on('input', function () {
        handleInput(sliderOne, inputOne, parseInt(sliderTwo.val()) - parseInt(sliderOne.val()) <= minGap, parseInt(sliderTwo.val()) - minGap)
      })
      sliderTwo.on('input', function () {
        handleInput(sliderTwo, inputTwo, parseInt(sliderTwo.val()) - parseInt(sliderOne.val()) <= minGap, parseInt(sliderOne.val()) - minGap)
      })
      inputOne.on('change', function () {
        handleInput(inputOne, sliderOne, parseInt(inputTwo.val()) - parseInt(inputOne.val()) <= minGap, parseInt(inputTwo.val()) - minGap)
      })
      inputTwo.on('change', function () {
        handleInput(inputTwo, sliderTwo, parseInt(inputTwo.val()) - parseInt(inputOne.val()) <= minGap, parseInt(inputOne.val()) - minGap)
      })
      function fillColor() {
        sliderTrack.css('left', `${((sliderOne.val() - sliderMinValue) / sliderGap * 100)}%`);
        sliderTrack.css('right', `${100 - (sliderTwo.val() - sliderMinValue) / sliderGap * 100}%`);
      }
      function handleReset() {
        setTimeout(function () {
          sliderOne.val(inputOne.val());
          sliderTwo.val(inputTwo.val())
          fillColor();
        }, 0)
      }
      if (inputOne.attr('form')) {
        $(`#${inputOne.attr('form')}`).on('reset', handleReset)
      } else {
        inputOne.closest('form').on('reset', handleReset)
      }
    })
    $('.range', context).each(function () {
      var elem = $(this);
      var slider = elem.find('input[type="range"]');
      var input = elem.find('input[type="number"]');
      var sliderTrack = elem.find(".progress-part");
      var sliderMaxValue = slider.attr('max');
      fillColor();
      slider.on('input change', function () {
        input.val($(this).val());
        fillColor();
      })
      input.on('change', function () {
        slider.val($(this).val());
        fillColor();
      })
      function fillColor() {
        slider.val(input.val() || 0);
        sliderTrack.css('left', '0%');
        sliderTrack.css('right', `${100 - ((input.val() || 0) / sliderMaxValue) * 100}%`);
      }
      function handleReset() {
        setTimeout(function () {
          slider.val(input.val())
          fillColor();
        }, 0)
      }
      if (input.attr('form')) {
        $(`#${input.attr('form')}`).on('reset', handleReset)
      } else {
        input.closest('form').on('reset', handleReset)
      }
    })
  }
})